var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "push-settings",
    },
    [
      _c("h2", [_vm._v("消息推送设置")]),
      _c("el-alert", {
        attrs: {
          type: "info",
          closable: false,
          title:
            "手机通知由推送服务商发送；PC通过在线提醒事件显示桌面通知。通知不代表已读，DING仍需打开卡片确认。",
        },
      }),
      _vm.error
        ? _c("p", { staticClass: "error", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm.form
        ? _c(
            "el-form",
            {
              attrs: {
                "label-width": "150px",
                disabled: !_vm.canWrite || _vm.saving,
              },
            },
            [
              _c("p", { staticClass: "channel-status" }, [
                _vm._v(
                  "当前手机推送：" +
                    _vm._s(
                      _vm.form.provider === "OFF"
                        ? "已关闭"
                        : _vm.form.provider === "JPUSH"
                        ? "极光 JPush"
                        : "UniPush"
                    )
                ),
              ]),
              _c(
                "el-tabs",
                {
                  staticClass: "channel-tabs",
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.channel,
                    callback: function ($$v) {
                      _vm.channel = $$v
                    },
                    expression: "channel",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "极光 JPush", name: "JPUSH" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用极光推送" } },
                        [
                          _c("el-switch", {
                            attrs: { value: _vm.form.provider === "JPUSH" },
                            on: {
                              change: function ($event) {
                                return _vm.setProvider("JPUSH", $event)
                              },
                            },
                          }),
                          _c("small", [
                            _vm._v(
                              "启用后替换当前手机推送通道；关闭后停止手机推送。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "极光 AppKey" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "24",
                              autocomplete: "off",
                              placeholder: "极光控制台的24位AppKey",
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "appKey",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Master Secret" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              "show-password": "",
                              maxlength: "24",
                              autocomplete: "new-password",
                              placeholder: _vm.form.secretConfigured
                                ? "已保存；留空保留原密钥"
                                : "未配置；仅在保存时传给后端",
                            },
                            model: {
                              value: _vm.form.masterSecret,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "masterSecret",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.masterSecret",
                            },
                          }),
                          _c("small", [
                            _vm._v(
                              "密钥不回显、不下发给App/PC。更换AppKey时须同时更换密钥。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "iOS APNs环境" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "生产（发布包）",
                              "inactive-text": "开发",
                            },
                            model: {
                              value: _vm.form.apnsProduction,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apnsProduction", $$v)
                              },
                              expression: "form.apnsProduction",
                            },
                          }),
                          _c("small", [
                            _vm._v(
                              "必须与iOS签名及极光控制台APNs证书一致；不影响Android。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      !_vm.form.encryptionReady
                        ? _c("el-alert", {
                            attrs: {
                              type: "warning",
                              closable: false,
                              title:
                                "后端尚未配置 CHAT_PUSH_CONFIG_ENCRYPTION_KEY：请运维设置32字节随机密钥的Base64值。配置之前不能保存Secret或启用极光。",
                            },
                          })
                        : _vm._e(),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(
                          "Android包名：com.jiuhang.hxt。手机需安装集成极光的新APK，并同意推送隐私说明/开启系统通知。厂商离线通道还需在极光控制台配置厂商凭据并重新打包；强行停止App后的提醒不能保证。"
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: !_vm.form.secretConfigured },
                          on: { click: _vm.validate },
                        },
                        [_vm._v("校验已保存的凭据")]
                      ),
                      _c("span", { staticClass: "hint" }, [
                        _vm._v("校验不会向员工发送通知。"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "UniPush", name: "UNIPUSH" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用 UniPush" } },
                        [
                          _c("el-switch", {
                            attrs: { value: _vm.form.provider === "UNIPUSH" },
                            on: {
                              change: function ($event) {
                                return _vm.setProvider("UNIPUSH", $event)
                              },
                            },
                          }),
                          _c("small", [
                            _vm._v(
                              "启用后替换当前手机推送通道；关闭后停止手机推送。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("el-alert", {
                        attrs: {
                          type: "info",
                          closable: false,
                          title:
                            "使用服务端已配置的 UniPush 通道，无需填写极光 AppKey 或 Master Secret。",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(
                          "手机需安装集成 UniPush 的应用并允许系统通知。请确保服务端 UniPush 配置已完成后再启用。"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "离线保留秒数" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 60, max: 86400 },
                    model: {
                      value: _vm.form.ttlSeconds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ttlSeconds", $$v)
                      },
                      expression: "form.ttlSeconds",
                    },
                  }),
                  _c("small", [
                    _vm._v(
                      "60～86400秒。过期、已读、已撤回的业务不再重试提醒。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "PC在线提醒" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.pcEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pcEnabled", $$v)
                      },
                      expression: "form.pcEnabled",
                    },
                  }),
                  _c("small", [
                    _vm._v(
                      "PC退出程序后不再提醒；最小化时可提醒。个人仍可关闭通知或声音。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "提醒业务" } },
                _vm._l(_vm.kinds, function (item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.key,
                      model: {
                        value: _vm.form[item.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, item.key, $$v)
                        },
                        expression: "form[item.key]",
                      },
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.save },
                },
                [_vm._v("保存设置")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.error
        ? _c("el-button", { on: { click: _vm.load } }, [_vm._v("重新加载")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }